export default{
    get(url,data={}){
        return $.ajax({
            url: "/sibh/api/v2/"+url,
            type:"GET",
            data: data,
            headers: {'User-Email': cookies.user_email, 'User-Token': cookies.user_token},
            success: function(data){
                return data
            }
        })
    },
    post(url, data={}){
        return $.ajax({
            url: "/sibh/api/v2/"+url,
            type:"POST",
            data: data,
            headers: {'User-Email': cookies.user_email, 'User-Token': cookies.user_token},
            success: function(data){
                return data
            }
        })
    },
    request(url, type, data, addOptions = {}){        
        return $.ajax({
            // url: "https://cth.daee.sp.gov.br/sibh/api/v2/"+url,
            // url: 'http://localhost:11000/'+url,
            url: AMBIENT === 'development' ? 'https://cth.daee.sp.gov.br/sibh/api/v2/'+url : "/sibh/api/v2/"+url,
            type:type,
            data: data,
            headers: {'User-Email': cookies.user_email, 'User-Token': cookies.user_token},
            success: function(data){
                return data
            },
            ...addOptions
        })
    }
}